export const s = 1e3;
export const m = 6e4;
export const h = 36e5;
export const d = 864e5;
export const w = 6048e5;
//# sourceMappingURL=ms.js.map